<template> 
    <div class="card-notassigned" >

        <div class="row align-items-center">
            <div class="col-12"  @click="clickChat(element)">
                <div class="row align-items-center">
                    <div class="col-2">
                        <div class="circle d-flex align-items-center justify-content-center">
                            <ficon :icon="['fa', 'comment-alt']" v-if="element.channel == 'chat'"></ficon>
                            <ficon :icon="['fa', 'sms']" v-if="element.channel == 'sms'" ></ficon>
                            <ficon :icon="['fab', 'whatsapp']" v-if="element.channel == 'whatsapp'"></ficon>
                        </div>
                    </div>
                    <div class="col-10" >
                        <div class="row d-flex align-items-center">
                            <div class="col-9 d-flex justify-content-start align-items-center">
                                <strong>{{element.name}}</strong>
                            </div>
                            <div class="col-3">
                                
                            </div>
                        </div>
                        
                        <div class="row d-flex align-items-center">
                            <div class="col-7 d-flex justify-content-start last-message">
                                <i>{{element.last_message}} </i>
                            </div>
                            <div class="col-2">
                                <div class="circle-notify d-flex align-items-center justify-content-center">
                                    {{element.counter_notify}}
                                </div> 
                            </div>
                            <div class="col-3 justify-content-center">
                                <b-nav-item-dropdown no-caret class="unstyled p-0" toggle-class="nav-link-custom">
                                    <template slot="button-content">
                                        <ficon :icon="['fas', 'ellipsis-v']" class="color-icon"></ficon>
                                    </template>
                                    <b-dropdown-item @click="inCarico(element)">Prendi in Carico</b-dropdown-item>
                                </b-nav-item-dropdown>
                            </div>
                        </div>
                        <div class="row d-flex align-items-center">
                            <div class="col-9 d-flex justify-content-start" style="margin-top:5px;">
                                <sub> {{element.reparto}}</sub>
                            </div>
                        </div>
                    </div>

                   
                </div>
            </div>
           
        </div>
    </div>

</template>

<script>

    import defapp from "../models/defapp.js"

    export default {
        name: 'CardNotAssigned',
        data: function() {
            return  {
                date_orig : null
            };
        },
        props: ['element','callbackInCarico','showChat'],
        methods: {       
            inCarico: function(element) {
               this.callbackInCarico(element,1); 
            },
            clickChat: function(element)
            {
                this.showChat(element,defapp.TYPE_CHAT_NOT_ASSIGNED)
            }
        },
        computed: {  
            
        },
        mounted: function(){
           
        },
        created: function()
        {
            let date = new Date(this.element.date_orig * 1000)
            this.date_orig = date.toLocaleDateString()
        }
    }
</script>